import base from "./book-demo.json";

module.exports = {
	...base,
};
